import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M9.584 2.9A1.772 1.772 0 0 0 7.093.425L3.628 3.17a.5.5 0 0 0-.144.185l-.633 1.386a.25.25 0 0 1-.232.146 2.52 2.52 0 0 0-1.831.731c-.653.654-.724 2.8-.724 3.69a.625.625 0 0 0 .625.625c.891 0 3.036-.07 3.69-.724A2.52 2.52 0 0 0 5.11 7.38a.25.25 0 0 1 .147-.232l1.388-.631a.5.5 0 0 0 .186-.144ZM3.5 8.32a5.4 5.4 0 0 1-1.892.334.25.25 0 0 1-.265-.265A5.5 5.5 0 0 1 1.672 6.5 1.289 1.289 0 0 1 3.5 8.32"
    }, null, -1)
  ]));
}
const interfaceEditToolPen = { render };
export {
  interfaceEditToolPen as default,
  render
};
//# sourceMappingURL=interface-edit-tool-pen.svg.js.map
